export const environment = {
  production: false,
  hmr: false,
  debug: false,
  client: 'Ferrari-NA',
  hostName: 'analytics-staging.ferraridealers.com',
  environmentName: 'staging',
  appName: 'Ferrari Analytics',
  applicationInsights: {
    instrumentationKey: '72ef1b3f-a524-4dcf-84d7-d80d9ac64287'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Eastern Standard Time',
  numberOfMonthsToShowDefault: 12,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  ssoPassword: 'ShiftDigital#123',
  defaultChartColors: ['#34383c', '#c51230', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  baseApiUri: '',
  authUri: '',
  baseV5ApiUri: 'https://ferrarina-insight-apiv5-staging.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: false,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/ferrari-na/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
  v5Reports: []
};
